import React, { Component } from 'react';
import UserTransaction from './userTransaction';
import './editstyle.css';

class EditMembers extends Component {
  constructor(props){
    super(props)
    this.state={
      editText : true,
      password  :"",
      firstName:"",
      lastName:"",
      dob:"",
      gender:"",
      addressLineOne: "",
      addressLineTwo: "",
      state : "",
      country : "",
      pinCode : "",
      marriageStatus: "",
      contact_no:'',
      showTransactionComponent: false,
    };
    this.edit = this.edit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.memberList = this.memberList.bind(this);
    this.showTransactionByuserID = this.showTransactionByuserID.bind(this);
    this.backEditMember = this.backEditMember.bind(this);
    this.showDemographicsByUser = this.showDemographicsByUser.bind(this);
  }

  onChange(e){
  this.setState({[e.target.name]: e.target.value});
  }

  componentDidMount() {
    if(this.props.userProfile===undefined || this.props.userProfile === null ){
      this.setState({

      });
    }
    else {
        this.setState({
            profileId : this.props.userProfile._id,
            email : this.props.userProfile.Email,
            password  : this.props.userProfile.Password,
            firstName: this.props.userProfile.First_name,
            lastName: this.props.userProfile.Last_name,
            dob: this.props.userProfile.D_O_B,
            gender: this.props.userProfile.Gender,
            addressLineOne: this.props.userProfile.Address_line_one,
            addressLineTwo: this.props.userProfile.Address_line_two,
            state: this.props.userProfile.State,
            country: this.props.userProfile.Country,
            pinCode: this.props.userProfile.Pincode,
            marriageStatus: this.props.userProfile.Marriage_status,
            contact_no : this.props.userProfile.Contact
        });
      }
	}

  edit(){
    this.setState({
     editText : false
  });
}

updateProfile(){
  let profileData = {};
  profileData.email = this.state.email,
  profileData.profileId = this.state.profileId,
  profileData.password  = this.state.password,
  profileData.firstName  = this.state.firstName,
  profileData.lastName  = this.state.lastName,
  profileData.dob = this.state.dob,
  profileData.gender  = this.state.gender,
  profileData.Address_line_one = this.state.addressLineOne,
  profileData.Address_line_two = this.state.addressLineTwo,
  profileData.State = this.state.state,
  profileData.Country = this.state.country,
  profileData.Pincode = this.state.pinCode,
  profileData.marriageStatus  = this.state.marriageStatus,
  profileData.contact =  this.state.contact_no
  this.props.updateProfile(profileData);
  this.setState({
   editText : true
  });
}

memberList(){
  this.props.backMemberList();
}
showTransactionByuserID(){
  this.props.showTransactionByuserID(this.state.profileId);
  this.setState({showTransactionComponent : true})
}

backEditMember(){
  this.props.backMemberList();
  //this.setState({showTransactionComponent : false})
}

showDemographicsByUser(){
 this.props.userDemographics(this.state.profileId);
}

  render(){
    let setProfile ="";
    if(this.state.editText){
     setProfile = <div>
                  <button  className="registerbtn" onClick={this.edit} >Edit</button>
                  </div>
    }else{
      setProfile = <div>
                   <button  className="registerbtn"   onClick={this.updateProfile} >Update</button>
                   </div>
    }


    let showComponents= "";

    if(this.state.showTransactionComponent){

      showComponents = <UserTransaction
      UserTranactionSuccess = {this.props.UserTranactionSuccess}
      UserTranactionData = {this.props.UserTranactionData}
      backEditMember = {this.backEditMember}
                      />

    }else{
      showComponents =  <div className = "regPage">
      <div className = "form">
      <div className = "GNNheading"><h1>Profile Update</h1></div>
          
          
      <br/><button  className = "backbutton" onClick={this.memberList}>Back</button>
      <button  className = "backbutton" style = {{float:"right", marginRight: "30px"}} onClick={this.showTransactionByuserID}>Transaction</button>
      <button  className = "backbutton" style = {{float:"right", marginRight: "20px"}} onClick={this.showDemographicsByUser}>Check Demographics</button>
      <br/>
           
           <div className = "registerform">
                <label>First name</label>
                <input type="text" className = "formInputtextName" placeholder="Enter First name" name="firstName" value={this.state.firstName} onChange={this.onChange} disabled = {this.state.editText}  /><br/>
                <label>Last name</label>
                <input type="text" className = "formInputtextName" placeholder="Enter Last name" name="lastName" value={this.state.lastName} onChange={this.onChange} disabled = {this.state.editText} /><br/>
                <label>Email</label>
                <input type="text" className = "formInputtextName" placeholder="Enter email" name="email" value={this.state.email} onChange={this.onChange} disabled = {this.state.editText} /><br/>
                <label>D.O.B.</label>
                <input type="date" className = "formInputtextdob" name="dob"  value={this.state.dob} onChange={this.onChange}  disabled = {this.state.editText}  /><br/>
                <label>Gender</label>
                <select className = "formAddMerrage"  name="gender" placeholder="gender" onChange={this.onChange}  value={this.state.gender} disabled={this.state.editText}>
                <option value="0">Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Shemale">Shemale</option>
                <option value="Transgender">Transgender</option>
                <option value="Others">Others</option>
              </select><br/>
              
                <label> Address  </label><br/>
                <label className = "addLabel"> Line one: </label><input type="text" className = "formAddress" name ="addressLineOne" value={this.state.addressLineOne} onChange={this.onChange} disabled = {this.state.editText}/><br/>
                <label> Line two: </label><input type="text" className = "formAddress" name ="addressLineTwo" value={this.state.addressLineTwo} onChange={this.onChange} disabled = {this.state.editText}/><br/>
                <label> State/Province</label><input type="text" className = "formAddCountry" name ="state" value={this.state.state} onChange={this.onChange} disabled = {this.state.editText}/><br/>
                <label> Country</label><input type="text" className = "formAddState" name ="country"state value={this.state.country} onChange={this.onChange} disabled = {this.state.editText}/><br/>
                <label> Pincode</label><input type="text" className = "formAddPin" name ="pinCode" value={this.state.pinCode} onChange={this.onChange} disabled = {this.state.editText}/><br/>
                <label>Marriage status</label>
                <select type="select"  className = "formAddMerrage" name ="marriageStatus" placeholder="marriage"  value={this.state.marriageStatus} onChange={this.onChange} disabled={this.state.editText}>
                  <option value="0">Marriage Status</option>
                  <option value="Married">Married</option>
                  <option value="UnMarried">UnMarried</option>
                  <option value="Lesbian">Lesbian</option>
                  <option value="Gay">Gay</option>
                  <option value="Divorced">Divorced</option>
                  <option value="Register Partner">Register Partner</option>
                  <option value="Other">Other</option>
                </select><br/>
                <label> Contact No </label><input type="text" className = "formAddPin" name ="contact_no" value={this.state.contact_no} onChange={this.onChange} disabled = {this.state.editText}/><br/>
                
                <div>
                <br/>
                <div className = "registerbutton">{setProfile}</div>
                <br/>
                </div>
                </div>
              </div>
      </div>
    }

    return (<div>{showComponents}</div>
     
    );
  }
}
export default EditMembers;



// WEBPACK FOOTER //
// ./src/components/country/editMembers.js